var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-header"},[_c('img',{staticClass:"logo-image",attrs:{"src":require("../../assets/images/logo4.png")}})])
}]

export { render, staticRenderFns }